/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_GroupInputs */



/**
* | output |
* | --- |
* | "Source Group" |
*
* @param {Source_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const source_group = /** @type {((inputs?: Source_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quellengruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di origine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа источников")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("来源组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de origem")
	return /** @type {LocalizedString} */ ("Source Group")
});